var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyClipboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2499 3.0625V0.625H7.40613C6.72058 0.625 6.18738 1.18359 6.18738 1.84375V9.15625C6.18738 9.8418 6.72058 10.375 7.40613 10.375H12.2811C12.9413 10.375 13.4999 9.8418 13.4999 9.15625V3.875H11.0624C10.6053 3.875 10.2499 3.51953 10.2499 3.0625ZM11.0624 0.625V3.0625H13.4999L11.0624 0.625ZM5.37488 9.5625V3.875H1.71863C1.03308 3.875 0.499878 4.43359 0.499878 5.09375V12.4062C0.499878 13.0918 1.03308 13.625 1.71863 13.625H6.59363C7.25378 13.625 7.81238 13.0918 7.81238 12.4062V11.1875H6.99988C6.08582 11.1875 5.37488 10.4766 5.37488 9.5625Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboardIcon);
export default __webpack_public_path__ + "static/media/copy-clipboard-icon.53e032f61267f6cba1354ce7c31c9bed.svg";
export { ForwardRef as ReactComponent };